var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.71V5.16C13 2.311 10.761 0 8 0C5.239 0 3 2.31 3 5.161V6.71H1V14.968C1 15.538 1.448 16 2 16H14C14.552 16 15 15.538 15 14.968V6.71H13ZM5 5.16C5 2.755 6.51 1.671 8 1.671C9.49 1.671 11 2.704 11 5.161V6.71H5V5.16ZM9 12.902H7V9.806H9V12.903V12.902Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.8045b49296d3b6509c36232ceb86f86a.svg";
export { ForwardRef as ReactComponent };